import React, { useState, useEffect, useContext, useRef } from 'react'
import { useMutation, useLazyQuery } from 'components/graphql'
import gql from 'graphql-tag'
import Button from 'components/Button'
import { StatusIndicatorContext } from 'components/graphql/context/StatusIndicatorContext'

const initRemoteAccessMutation = gql`
	mutation initRemoteAccess($hardwareId: ID!) {
		initRemoteAccess(hardwareId: $hardwareId)
	}
`

const getRemoteAccessParamsQuery = gql`
	query getRemoteAccessParams($sessionId: ID!) {
		getRemoteAccessParams(sessionId: $sessionId) {
	    sessionId
	    password
	  }
	}
`

const RemoteControlButton = ({ hardwareId, ...props }) => {
	const maxRCSessionPollAttempts = 10
	const [remoteControlSessionPollAttempts, setRemoteControlSessionPollAttempts] = useState(0)
	const { addPromise } = useContext(StatusIndicatorContext)
	const getSessionPromiseHandle = useRef()
	const [initRemoteAccess] = useMutation(initRemoteAccessMutation, {
		variables: { hardwareId },
		withIndicator: false
	})
	const [startPolling, { stopPolling }] = useLazyQuery(getRemoteAccessParamsQuery, {
		pollInterval: 2000,
		onCompleted: ({ getRemoteAccessParams }) => {
			const { resolve, reject } = getSessionPromiseHandle?.current || {}
			if(getRemoteAccessParams) {
				setRemoteControlSessionPollAttempts(maxRCSessionPollAttempts)
				if(resolve) {
					resolve()
				}
				const url = `https://apuppet.hssoft.com/web-admin/?session=${getRemoteAccessParams.sessionId}&pin=${getRemoteAccessParams.password}`
				window.open(url, '_blank').focus()
			} else {
				setRemoteControlSessionPollAttempts(prev => {
					if(prev + 1 === maxRCSessionPollAttempts) {
						if(reject) {
							reject('Remote control device is not responding')
						}
					}
					return prev + 1
				})
			}
		},
		onError: (err) => getSessionPromiseHandle?.current?.reject?.(err)
	})

	const handleGetSession = (sessionId) => new Promise((resolve, reject) => {
		startPolling({ variables: { sessionId } })
		getSessionPromiseHandle.current = { resolve, reject }
	})

	useEffect(() => {
		if(remoteControlSessionPollAttempts >= maxRCSessionPollAttempts) {
			setRemoteControlSessionPollAttempts(0)
			return stopPolling()
		}
	}, [remoteControlSessionPollAttempts])


	const handleRemoteControl = e => {
		const promise = initRemoteAccess().then(({ data }) => {
			return handleGetSession(data.initRemoteAccess)
		})
		addPromise(promise)
	}

	return <Button onClick={handleRemoteControl} {...props}/>
}

export default RemoteControlButton
